import { Button, Icon, Layout, Text, useTheme } from '@ui-kitten/components';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import Spinner from 'react-native-loading-spinner-overlay/lib';
import { mainStyles } from 'src/screens/main/_mainStyles';

type NotConnectedProps = {
  onRetry?: () => void;
  loading?: boolean;
};

const NotConnected: React.FC<NotConnectedProps> = ({ onRetry, loading = false }) => {
  const styleContainer = StyleSheet.create({
    notEnabled: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center'
    },
    container: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      margin: 16
      // maxWidth: uh.h2DP(256)
    },
    button: {
      marginTop: 24,
      minWidth: 150
    },
    text: {
      textAlign: 'center',
      paddingVertical: 8
    }
  });

  const th = useTheme();
  const message = 'No internet connection found. Please check Your connection.';
  return (
    <Layout level="2" style={[styleContainer.notEnabled, mainStyles.mainScreenContainer]}>
      {loading && <Spinner visible={true} />}
      <View style={styleContainer.container}>
        <Icon
          style={{ width: 128, height: 128, paddingBottom: 24 }}
          fill={th['color-primary-500']}
          name={'wifi-off-outline'}
        />
        <View>
          <Text category="h5" style={styleContainer.text}>
            Not connected!
          </Text>
          <Text category="p1" style={styleContainer.text}>
            {message}
          </Text>
        </View>
        <Button style={styleContainer.button} size="medium" onPress={onRetry}>
          <Text>Try again</Text>
        </Button>
      </View>
    </Layout>
  );
};

export default NotConnected;
